function ticker(tickerEl) {

  const banner = document.querySelector('.js-banner'),
        tickerWidth = tickerEl.offsetWidth,
        tickerTrack = tickerEl.querySelector('.ticker__track'),
        tickerItem = tickerEl.querySelector('.ticker__item'),
        tickerItemWidth = tickerItem.offsetWidth,
        numberClones = Math.ceil(tickerWidth / tickerItemWidth),
        duration = 10 + (tickerWidth * .015);

  if(banner) {
      banner.classList.add('has-ticker');
  }
      
  for (let i = 0; i < (numberClones * 3); i++) {
      let spans = tickerItem.cloneNode(true);
      tickerTrack.appendChild(spans);
  }

  gsap.to(tickerTrack, {
      x: -tickerTrack.offsetWidth,
      repeat: -1,
      ease:'linear',
      duration: duration,
      onStart: () => {
          tickerEl.classList.remove('loading');
      }
  });
}
